import { connect } from 'react-redux';
import PlanningBoardGantt from '../components/planning-board-gantt';

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PlanningBoardGantt);
